import styled from '@emotion/styled';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';

export const StyledHolidayImage = styled('div')<{ image?: string; theme?: any }>(
  ({ image, theme }) => ({
    backgroundRepeat: 'no-repeat',
    width: '80%',
    height: 70,
    borderRadius: '50px',
    overflow: 'hidden',
    display: 'flex',
    padding: 0,
    margin: 0,
    alignItems: 'center',
    paddingLeft: 20,
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    backgroundImage: `linear-gradient(to bottom, ${theme.palette.primary.main}, ${theme.palette.primary.main}), url(${image})`,
    backgroundPosition: 'center',
    backgroundSize: '90% 90%',
  })
);

export const StyledText = styled('text')<{ theme?: any }>(({ theme }) => ({
  fill: theme.palette.text.primary,
  textAnchor: 'middle',
  fontSize: 20,
}));

export const BorderLinearProgress = styled(LinearProgress)<{ theme?: any }>(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette?.grey[theme.palette.mode === 'light' ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette?.quaternary.dodgerBlue,
  },
}));
